import { TIMEZONES } from './timezone'

export const useAvailableTimezones = (): string[] => TIMEZONES
